import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
import { CONSENTS_GROUP_FIELDS } from '@isyc-react/oc-api/fragments';
export const BAILLEURS_DOSSIER_QUERY = gql `
    ${CONSENTS_GROUP_FIELDS}
    query bailleursDossierRead($dossierId: Long) {
      bailleurs_dossier_read(dossierId: $dossierId) {
        id
        step
        name
        businessUnitName
        businessUnitId
        dossierNumber
        consentsGroup {
          ...ConsentsGroupFields
        }
        participants {
          id
          name
        }
      }
    }
  `;
export const useBailleursDossierReadLazyQuery = (options) => {
    return useLazyQuery(BAILLEURS_DOSSIER_QUERY, Object.assign({ errorPolicy: 'all' }, options));
};
export const useBailleursDossierReadQuery = (options) => {
    return useQuery(BAILLEURS_DOSSIER_QUERY, Object.assign({ errorPolicy: 'all' }, options));
};
export const useBailleursDossierReadQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: BAILLEURS_DOSSIER_QUERY, variables }));
};
